export default __webpack_public_path__ + "static/media/solutions-carousel.0a5c75a6.webm";